import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Modal, Input, Select, Btn } from "@/components/UI";
import { fmtQty } from "@/lib/products";
import { apiError } from "@/lib/customers";

// Malzeme Stok → mevcut Satın Alma modülünde TASLAK PO (satır tipi: material).
export function MaterialPurchaseModal({ row, suppliers, onClose, onDone }) {
  const [f, setF] = useState({ supplier_id: "", qty: "", unit_price: 0, expected_delivery: "" });
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);
  useEffect(() => {
    if (row) {
      const need = Math.max(0, row.m.critical_stock * 2 - row.m.stock_qty);
      setF({ supplier_id: row.m.default_supplier_id || "", qty: need ? String(Math.ceil(need)) : "", unit_price: 0, expected_delivery: "" });
      setErr("");
    }
  }, [row]);
  if (!row) return null;
  const { m, g } = row;
  const submit = async () => {
    const sup = suppliers.find((s) => s.id === f.supplier_id);
    if (!sup) return setErr("Tedarikçi seçin");
    if (!(Number(f.qty) > 0)) return setErr("Miktar 0'dan büyük olmalı");
    setBusy(true); setErr("");
    try {
      const po = await api.post("/purchase-orders", {
        supplier: sup.name, supplier_id: sup.id, currency: "TRY", expected_delivery: f.expected_delivery || null, priority: "normal",
        notes: `Kaynak: Malzeme Stok — ${g.product_name} / ${m.name}`,
        lines: [{ material_id: m.id, line_kind: "material", qty: Number(f.qty), unit: (m.unit || "adet").toLowerCase(), unit_price: Number(f.unit_price) || 0 }],
      });
      onDone(po);
    } catch (e) { setErr(apiError(e, "Satın alma oluşturulamadı")); } finally { setBusy(false); }
  };
  return (
    <Modal open onClose={onClose} title="Malzeme Satın Alma (Taslak)">
      <div className="space-y-3" data-testid="material-po-modal">
        <div className="grid grid-cols-2 gap-2 text-sm rounded-lg bg-slate-50 p-3">
          <div>Ürün: <b data-testid="material-po-product">{g.product_name}</b></div>
          <div>Malzeme: <b data-testid="material-po-material">{m.name}</b> <span className="text-xs text-slate-500">({m.material_type})</span></div>
          <div>Mevcut Stok: <b data-testid="material-po-stock">{fmtQty(m.stock_qty)}</b></div>
          <div>Kritik Stok: <b>{fmtQty(m.critical_stock)}</b></div>
        </div>
        <Select label="Tedarikçi *" value={f.supplier_id} onChange={(e) => setF({ ...f, supplier_id: e.target.value })} data-testid="material-po-supplier">
          <option value="">Seçin…</option>{suppliers.map((s) => <option key={s.id} value={s.id}>{s.name}</option>)}
        </Select>
        <div className="grid grid-cols-3 gap-2">
          <Input label={`Miktar (${m.unit || "Adet"}) *`} type="number" min="0" step="any" value={f.qty} onChange={(e) => setF({ ...f, qty: e.target.value })} data-testid="material-po-qty" />
          <Input label="Birim Fiyat (TRY)" type="number" min="0" step="any" value={f.unit_price} onChange={(e) => setF({ ...f, unit_price: e.target.value })} data-testid="material-po-price" />
          <Input label="Beklenen Teslim" type="date" value={f.expected_delivery} onChange={(e) => setF({ ...f, expected_delivery: e.target.value })} data-testid="material-po-expected" />
        </div>
        {err && <div className="text-xs text-rose-600" data-testid="material-po-error">{err}</div>}
        <div className="flex justify-end gap-2">
          <Btn variant="secondary" onClick={onClose} data-testid="material-po-cancel">Vazgeç</Btn>
          <Btn onClick={submit} disabled={busy} data-testid="material-po-submit">{busy ? "Oluşturuluyor…" : "Taslak Satın Alma Oluştur"}</Btn>
        </div>
      </div>
    </Modal>
  );
}
